import { render } from "./external-access.vue?vue&type=template&id=9cbda9ac&scoped=true"
import script from "./external-access.vue?vue&type=script&lang=js"
export * from "./external-access.vue?vue&type=script&lang=js"

import "./external-access.vue?vue&type=style&index=0&id=9cbda9ac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cbda9ac"]])

export default __exports__